import { Select } from "./ui.js";

const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const pad = (n: number) => String(n).padStart(2, "0");

/**
 * A 12-hour time picker (hour, minute, am/pm). A native <input type="time"> shows the device's own
 * clock format, which can be 24-hour; this always shows 12-hour. The value is still a 24-hour
 * "HH:MM" string, so it saves exactly as the native input did.
 */
export function TimeInput12({ value, onChange, label }: { value: string; onChange: (hhmm: string) => void; label: string }) {
  const [hStr = "9", mStr = "0"] = (value || "09:00").split(":");
  const h24 = Math.min(23, Math.max(0, Number(hStr) || 0));
  const minute = Math.min(59, Math.max(0, Number(mStr) || 0));
  const pm = h24 >= 12;
  const hour12 = h24 % 12 === 0 ? 12 : h24 % 12;

  // 5-minute steps, plus the saved minute if it isn't one of them (so nothing is silently rounded).
  const minutes = Array.from({ length: 12 }, (_, i) => i * 5);
  if (!minutes.includes(minute)) minutes.push(minute), minutes.sort((a, b) => a - b);

  function emit(nextHour12: number, nextMinute: number, nextPm: boolean) {
    onChange(`${pad((nextHour12 % 12) + (nextPm ? 12 : 0))}:${pad(nextMinute)}`);
  }

  return (
    <span style={{ display: "inline-flex", gap: 4 }}>
      <Select aria-label={`${label} hour`} value={hour12} onChange={(e) => emit(Number(e.target.value), minute, pm)} style={{ width: "auto" }}>
        {HOURS.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </Select>
      <Select aria-label={`${label} minute`} value={minute} onChange={(e) => emit(hour12, Number(e.target.value), pm)} style={{ width: "auto" }}>
        {minutes.map((m) => (
          <option key={m} value={m}>
            {pad(m)}
          </option>
        ))}
      </Select>
      <Select aria-label={`${label} am or pm`} value={pm ? "pm" : "am"} onChange={(e) => emit(hour12, minute, e.target.value === "pm")} style={{ width: "auto" }}>
        <option value="am">am</option>
        <option value="pm">pm</option>
      </Select>
    </span>
  );
}
